export default __webpack_public_path__ + "static/media/Group 11011@2x.22d49a5d.png";